import { render, staticRenderFns } from "./playCascader.vue?vue&type=template&id=b5999c22&scoped=true"
import script from "./playCascader.vue?vue&type=script&lang=js"
export * from "./playCascader.vue?vue&type=script&lang=js"
import style0 from "./playCascader.vue?vue&type=style&index=0&id=b5999c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5999c22",
  null
  
)

export default component.exports